import {
  type RouteLocationNamedRaw,
  type RouteLocationNormalizedGeneric,
} from 'vue-router'

import { setPendingRedirect } from '@/auth/pendingRedirect'

export const getRedirectToLogin = (
  to: RouteLocationNormalizedGeneric
): RouteLocationNamedRaw => {
  setPendingRedirect(to.fullPath)

  return {
    name: 'auth.login',
  }
}
